import React, { useState, useEffect } from "react";
import Context from "../../Context";
import { useToast } from "../../components/ui";
import { Header } from "../../components/modules";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/base";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { BiLogIn } from "react-icons/bi";
import { IoReceiptOutline } from "react-icons/io5";
import { FiSearch, FiRefreshCw } from "react-icons/fi";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { FiCreditCard } from "react-icons/fi";
import constant, { statuses } from "../../constants";

export const DonateOrders = () => {
  const { callApi, updateConfig, configs } = Context();
  const { toast } = useToast();
  const [orders, setOrders] = useState(false);
  const [loading, setLoading] = useState(true);
  const [roundDate, setRoundDate] = useState(configs.roundDate);
  const [pages, setPages] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState("shortId");
  const [status, setStatus] = useState("");
  useEffect(() => {
    getOrders([]);
  }, [roundDate, status]);

  const getOrders = async () => {
    const queries = [["roundDate", roundDate]];

    if (status) {
      queries.push(["status", status]);
    }

    if (searchType && searchValue) {
      queries.push([searchType, searchValue]);
    }
    setLoading(true);
    const result = await callApi(
      "donates-getAllTransaction",
      {
        queries,
        limit: 1000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true }
    );

    const pages = {};
    let index = 1;
    const chunkSize = 50;
    for (let i = 0; i < result.length; i += chunkSize) {
      const chunk = result.slice(i, i + chunkSize);
      pages[index] = chunk;
      index++;
    }

    setPages(pages);
    setOrders(result);
    setLoading(false);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mx-auto pb-10 min-w-0">
      <Header
        header="Donates"
        subHeader={`บริจาคทั้งหมด`}
        icon={<FiCreditCard className="text-blue" />}
      />

      <div className="mt-4 bg-white rounded-md shadow-md border border-gray-200 p-4 flex flex-col gap-4">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            getOrders();
          }}
          className="flex flex-wrap items-end gap-3 shrink-0"
        >
          <div className="">
            <label className="text-xs font-bold text-gray-700">งวดสลาก</label>
            <div className="relative">
              <select
                className="h-10 w-full bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer appearance-none"
                onChange={(e) => setRoundDate(e.target.value)}
                value={roundDate || ""}
              >
                {configs.roundDates.map((date, index) => (
                  <option key={index} value={date}>
                    {date}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="">
            <label className="text-xs font-bold text-gray-700">สถานะ</label>
            <div className="relative">
              <select
                disabled={loading}
                className="h-10 w-full bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer appearance-none disabled:text-gray-400"
                value={status || ""}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={constant.statuses.APPROVE}>
                  {constant.statusesTranslate.approved}
                </option>
                <option value={constant.statuses.PAID}>
                  {constant.statusesTranslate.paid}
                </option>
                <option value={constant.statuses.CANCEL}>
                  {constant.statusesTranslate.canceled}
                </option>
              </select>
            </div>
          </div>

          <div className="">
            <label className="text-xs font-bold text-gray-700">ค้นหาตาม</label>
            <div className="relative">
              <select
                disabled={orders?.status === constant.statuses.CANCEL}
                className="h-10 w-full bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all cursor-pointer appearance-none disabled:text-gray-400"
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
              >
                <option value={`shortId`}>รหัสคำสั่งซื้อ</option>
                <option value={`user.phone`}>เบอร์โทรศัพท์</option>
                <option value={`user.userId`}>รหัสผู้ใช้</option>
                <option value={`user.name`}>ชื่อ</option>
              </select>
            </div>
          </div>

          <div className="">
            <label className="text-xs font-bold text-gray-700">คำค้นหา</label>
            <div className="relative flex items-center">
              <input
                className="h-10 w-full bg-white border border-gray-300 text-sm font-semibold rounded-md shadow-xs focus:outline-none focus:border-blue transition-all placeholder:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                type="text"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="พิมพ์เพื่อค้นหา..."
              />
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              disabled={loading}
              className="h-10 px-4 flex items-center justify-center gap-1.5 bg-blue hover:bg-blue/90 text-white text-sm font-bold rounded-md shadow-xs transition-all duration-150 disabled:opacity-50 cursor-pointer"
            >
              <FiSearch className="w-4 h-4" />
              <span>ค้นหา</span>
            </button>
            <button
              type="button"
              disabled={loading}
              className="h-10 px-4 flex items-center justify-center gap-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-bold rounded-md border border-gray-300 shadow-xs transition-all cursor-pointer disabled:opacity-50"
              onClick={async () => {
                setSearchValue("");
                setStatus("");
                getOrders([]);
              }}
            >
              <FiRefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
              <span>รีเซ็ต</span>
            </button>
          </div>
        </form>
      </div>

      <div className="mt-4 bg-white rounded-md shadow-md border border-gray-200 overflow-hidden">
        <div className="flex items-center p-4 border-b border-gray-200 bg-gray-50/60 justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-bold text-gray-800">บริจาคทั้งหมด</h2>
            <span className="px-2.5 py-0.5 text-xs font-bold bg-gray-200 text-gray-700 rounded-md">
              {orders ? orders.length : 0} รายการ
            </span>
          </div>

          <div>
            <Pagination>
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious
                    className={`${
                      currentPage > 1
                        ? "cursor-pointer"
                        : "cursor-not-allowed hover:bg-transparent opacity-45"
                    } font-semibold`}
                    onClick={() =>
                      setCurrentPage((prevState) =>
                        prevState > 1 ? prevState - 1 : 1
                      )
                    }
                  />
                </PaginationItem>

                {Object.keys(pages).map((x) => (
                  <PaginationItem key={x}>
                    <PaginationLink
                      className={`${
                        currentPage === Number(x)
                          ? "bg-blue text-white hover:bg-blue font-semibold"
                          : ""
                      } rounded-md cursor-pointer`}
                      onClick={() => setCurrentPage(Number(x))}
                    >
                      {x}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                <PaginationItem>
                  <PaginationNext
                    className={`${
                      pages[currentPage]?.length === 50 && currentPage < 10
                        ? "cursor-pointer"
                        : "cursor-not-allowed hover:bg-transparent opacity-45"
                    } font-semibold`}
                    onClick={() =>
                      pages[currentPage] > 50 &&
                      setCurrentPage((prevState) =>
                        prevState < 10 ? prevState + 1 : 10
                      )
                    }
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <Table>
            <TableHeader className="bg-gray-100/90 border-b border-gray-200">
              <TableRow className="hover:bg-transparent">
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">ลำดับ</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">เวลาสร้างคำสั่งซื้อ</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">รหัสคำสั่งซื้อ</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">รหัสผู้ใช้</TableHead>
                <TableHead className="font-bold text-gray-700 py-3 whitespace-nowrap">ชื่อผู้บริจาค</TableHead>
                <TableHead className="font-bold text-gray-700 py-3 whitespace-nowrap">เบอร์โทรศัพท์ผู้บริจาค</TableHead>
                <TableHead className="font-bold text-gray-700 py-3 whitespace-nowrap">สถานที่บริจาค</TableHead>
                <TableHead className="text-right font-bold text-gray-700 py-3 whitespace-nowrap">จำนวน</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">สลิป</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">สถานะ</TableHead>
                <TableHead className="text-center font-bold text-gray-700 py-3 whitespace-nowrap">จัดการ</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading ? (
                <TableRow className="h-[80px]">
                  <TableCell colSpan="11">
                    <div className="w-full h-72 flex flex-col justify-center items-center gap-3 text-gray-500">
                      <div className="w-8 h-8 border-4 border-blue border-t-transparent rounded-full animate-spin" />
                      <p className="text-sm font-semibold">กำลังโหลดข้อมูลบริจาค...</p>
                    </div>
                  </TableCell>
                </TableRow>
              ) : orders.length === 0 ? (
                <TableRow className="h-[80px]">
                  <TableCell
                    colSpan="11"
                    className="h-72 font-semibold text-center text-gray-400"
                  >
                    ไม่พบข้อมูล
                  </TableCell>
                </TableRow>
              ) : (
                pages[currentPage]
                  ?.sort((a, b) => b.createdAt - a.createdAt)
                  ?.map((coupon, index) => {
                    return (
                      <OrderCell
                        order={coupon}
                        key={coupon.id}
                        index={index}
                        getOrders={getOrders}
                      />
                    );
                  })
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

const OrderCell = ({ order, index }) => {
  const { callApi } = Context();
  const [loading, setLoading] = useState(false);
  return (
    <TableRow className="h-[80px]">
      <TableCell className="text-center font-semibold">{index + 1}</TableCell>
      <TableCell className="whitespace-nowrap text-center">
        <div className="font-semibold">
          {new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })}{" "}
          น.
        </div>
      </TableCell>
      <TableCell className="text-center font-bold font-mono tabular-nums">
        {order.shortId}
      </TableCell>
      <TableCell className="font-semibold text-center font-mono">
        <p>{order.user?.userId}</p>
      </TableCell>
      <TableCell className="font-semibold">{order.user?.name}</TableCell>
      <TableCell className="font-semibold">{order.user?.phone}</TableCell>
      <TableCell className="font-semibold">{order.donate?.name}</TableCell>
      <TableCell className="font-semibold text-right">
        {order.donateAmount?.toLocaleString()}{" "}
        {order.isDonateWithCash ? "บาท" : "คะแนน"}
      </TableCell>
      <TableCell className="font-semibold text-center">
        {order.slip ? (
          <img
            onClick={() => window.open(order.slip, "_blank")}
            src={order.slip}
            className="mx-auto w-16 max-h-20 object-contain cursor-pointer rounded-sm"
            alt="slip"
          />
        ) : (
          "-"
        )}
      </TableCell>
      <TableCell className="font-semibold text-center">
        <div
          className={`${
            order.status === statuses.APPROVE
              ? "bg-green"
              : order.status === statuses.PAID
              ? "bg-blue"
              : order.status === statuses.PENDING
              ? "bg-amber-500"
              : "bg-rose-600"
          } min-w-14 w-fit px-3 py-1.5 text-white text-xs font-bold text-center rounded-md mx-auto`}
        >
          {constant.statusesTranslate[order.status] || order.status}
        </div>
      </TableCell>
      <TableCell>
        <div className="flex justify-center gap-2">
          <button
            title="เข้าสู่ระบบในชื่อผู้ใช้"
            className="flex items-center justify-center p-2 bg-blue text-white rounded-md shadow-xs hover:bg-blue/90 transition-all cursor-pointer disabled:opacity-50"
            onClick={async () => {
              setLoading(true);
              let reasult = await callApi("users-addAdminToken", {
                userId: order.userId,
              });
              if (reasult?.adminToken) {
                window.open(constant.getAdminOrderUrl(reasult.adminToken));
              }
              setLoading(false);
            }}
          >
            {loading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <BiLogIn className="w-4 h-4" />}
          </button>
          <button
            title="ดูรายละเอียด"
            className="bg-green rounded-md p-2 text-white hover:opacity-85 transition-all cursor-pointer inline-flex items-center justify-center"
            onClick={() => window.open("/donate/order/" + order.id, "_blank")}
          >
            <HiOutlineDocumentSearch className="w-4 h-4" />
          </button>
        </div>
      </TableCell>
    </TableRow>
  );
};
